import { registerBlockType } from '@wordpress/blocks';

import './style.scss';

import Edit from './edit';
import save from './save';
import { buttons } from '../../utils/icons';

registerBlockType('asl/advanced-buttons', {
	icon: buttons,
	edit: Edit,
	save,
});
